<template>
      <div class="publicViewClass PrintingPaper" style="padding-top:0" id="publicWaterMark">
    <div class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enTestPaper')">
            返回
            </div>
            </div>
            <div class="flex height-100">
                <div class="left"   >
                       <div class="question-content" id="exportBox">
                        <div class="split-line"  v-if="Divider">
                            <div class="edit-show">
                                <span class="set-paper-1-value">
                                    姓名________     班级________    学号________
                                </span>
                            </div>
                            <span class="split-line-font">分</span>
                            <span class="split-line-font" style="top:50%">割</span>
                            <span class="split-line-font" style="top:70%">线</span>
                        </div>
                        <div class="default-div text-left" style="padding-right:100px">
                            <div class="question-title">
                                <span>{{list.paperName}}
                                </span>
                            </div>
                            <div class="question-time" v-if="paperSorce">
                                <div class="edit-show">
                                    <span class="set-paper-5-value">
                                        （全卷满分：{{list.paperScore}}，考试时间：{{list.answerTimeLimit}}分钟）
                                    </span>
                                </div>
                            </div>
                            <div class="question-title set-paper-3" style="font-size: 20px; display: block;" v-if="Information">
                                <div class="edit-show">
                                    <div class="set-paper-3-value">
                                        姓名________     班级________    学号________
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="default-div  text-left">
                            <div class="question-precautions" v-if="note">
                                <div class="edit-show">
                                    <p>*注意事项：</p>
                                </div>
                                <div class="set-paper-4-value" style="white-space: pre-line;line-height: 30px;">
                                    1.答题时用2B铅笔在答题卡内正楷字体填写，答案请写在密封线内和试卷正面，否则不计分。<br>
                                    2.考生须独立完成答卷，不得讨论，不得传抄。
                                </div>
                            </div>
                        </div>  
                        <div class="default-div  text-left">
                            <ul>
                                <li v-for="(item,index) in questions">
                                    <div class="question-topic">
                                         <div class="ques-title flex align-cen">
                                            <div class="ques-number">{{index + 1}}、</div>
                                            <span class="ques-type">{{$util.getTopicType(item.type)}}</span>
                                                <span v-html="item.title" style="max-width:60%" :class="item.type == 9 ? 'clozeClass' : ''"></span>
                                                <AudioTem :audioSrc="item.audio" v-if="item.audio"></AudioTem>
                                                <span class="ques-sorce" >（{{item.score}}分）</span>
                                            </div>
                                              <div class="question-option-list"> 
                        <ol  v-if="item.type !=4 && item.type != 9 && item.type != 5" class="flex olf">
                        <li v-for="(sonitem,sonIndex) in item.answerList" class="flex">
                            {{Eng[sonIndex]}}. <p v-html="sonitem.content"></p>
                        </li>
                            </ol>
                                <div class="clzoe" v-if="item.type == 9">
                                <div class="clzoeItem" v-for="(sonitem,sonIndex) in item.answerList" :key="sonIndex">
                                <p class="cloze-op-p" style="margin-left:-25px">
                                    <strong> {{sonIndex + 1}}:</strong>
                                </p>
                                <ol >
                                    <li  v-for="(sonitem1,sonIndex1) in item.answerList[sonIndex].clozeList" :key="sonIndex1">
                                        <p v-html="sonitem1.content"></p>
                                    </li>
                                </ol>
                                </div>
                            </div>
                   <div class="test_result" v-if="isTrue">
                     <div class="refAnswer"  v-if="item.type == 5">
                              <div class="detailKeyWorld" v-if="item.rule">
                                  <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                                  <p>关键字：</p>
                                      <p v-for="(sonitem,sonIndex) in item.answerList">
                                      {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length-1">，</span>
                                  </p>
                                  </div>
                              </div>
                              <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                          </div>
                        <div class="rightAnswer flex">
                             <span v-if="item.type !=4 && item.type != 7 && item.type != 9 && item.type != 5">
                                正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{Eng[sonIndex]}}
                                </strong>
                                </span>
                            </span>
                               <span v-if="item.type == 5" class="flex align-cen" style="color:#009aff">
                                  参考答案：
                                  <span v-html="item.refAnswer"></span>
                              </span>
                                  <span v-if="item.type == 7">
                                    正确顺序：
                                    <span v-for="(sonitem,sonIndex) in item.sortedIndexes">
                                        <span>
                                        {{Eng[sonitem]}}
                                    </span>
                                    </span>
                                </span>
                                     <span v-if="item.type == 9">
                                    正确答案：
                                    <span v-for="(sonitem,sonIndex) in item.answerList">
                                                <span style="margin-right:20px">
                                                {{sonIndex + 1}}:
                                                <span v-for="(sonitem1,sonIndex1) in item.answerList[sonIndex].clozeList" :key="sonIndex1">
                                                    <span v-if="sonitem1.isRight == 1">{{Eng[sonIndex1]}}</span>
                                                </span>
                                                </span>
                                    </span>
                                </span>
                            <span v-if="item.type ==4">
                                 正确答案：
                                <span v-for="(sonitem,sonIndex) in item.answerList">
                                    <strong  v-if="sonitem.isRight == 1">
                                    {{sonitem.content}}<span v-if="sonIndex !=item.answerList.length - 1">，</span>
                                </strong>
                                </span>
                               </span>
                        </div>
                         <div class="jx">
                            题目解析：<span v-html="item.analysis || '暂无解析'"></span>
                         </div>
                    </div>
                    </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="g-question">
                    <div class="btn-group flex align-cen" @click="exportWordTpl">
                        导出PDF
                    </div>
             <el-button class="btn-group btn-set flex align-cen" @click="exportWordTpl1" :loading='uploadLoading' style="line-height:normal">
                     导出Word
              </el-button>
                    <div class="j-paper-style">
                        <div class="content-title flex" style="padding: 0 24px;justify-content:space-between">
                            <div class="left">试卷调整</div>
                            <div class="reset-paper" style="font-size: 14px;font-weight: normal;color: #36aafd;cursor: pointer;" @click="restc">重置模板</div>
                        </div>
                        <div style="padding:24px">
                            <div class="paper-label">
                               <div class="chk">
                                 <el-checkbox v-model="Divider">分割线</el-checkbox>
                               </div>
                                 <div class="chk">
                                <el-checkbox v-model="Information">考生信息填写</el-checkbox>
                               </div>
                                 <div class="chk">
                                 <el-checkbox v-model="note">注意事项</el-checkbox>
                               </div>
                                <div class="chk">
                                 <el-checkbox v-model="paperSorce">考试时间/总分</el-checkbox>
                               </div>
                               <div  style="border: dashed 1px #e6e6e6;margin:30px 0px 20px 0px;"></div>
                               <div class="isShowBtn" @click="isOpen">
                                 {{isTrue ? "隐藏答案和解析" : "显示答案和解析"}}
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
    </div>
      </div>       
</template>
<script>
import {getPaper,getAllTopic} from "@/api/enterprise/index"  //获取试卷详情、根据id查询题目列表
import mycomponents from "@/utils/compoments.js";
import PdfLoader from '@/utils/html2pdf.js' 
import axios from "axios";
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
export default {
    name:'ExportWord',
       components: {
         AudioTem: mycomponents.components.PublicAudio
    },
    data() {
        return {
            header:{},
            uploadLoading:false,
            list:{},
            questions:[],
             Eng:['A','B','C','D','E','F','G','H','I','J'],
             isTrue:false,
             Divider:true,
             Information:false,
             note:true,
             paperSorce:true
        }
    },
    created() {
        this.getPaperDetail()
        this.getTopicPage()
         let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
        // 导出
        exportWordTpl(){
           // 获取需要导出的局部内容  
            const content = document.getElementById('exportBox'); 
             this.pdfDownLoader = new PdfLoader(content, 'fileName', '')  // fileName -->导出文件名,  question-table -->防止被截断的class名
             this.pdfDownLoader.outPutPdfFn(this.list.paperName)
        },
           exportWordTpl1(){
                 this.uploadLoading = true
             axios
       .get(`${this.$config.baseUrl}/exam/paper/exportWord?paperId=${this.$route.query.id}&attention=1&timeScore=1&examinee=1`, {
        headers:this.headers,
         responseType: "blob",
       })
         .then(response =>{
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${this.list.paperName}.doc`);
                document.body.appendChild(link);
                link.click();
                this.uploadLoading = false
                document.body.removeChild(link); 
         })
         .catch(err =>{this.uploadLoading = false})
            },
         isOpen(){
        this.isTrue = !this.isTrue
      },
        restc(){
            // 重置模版
            this.Divider = true
            this.Information = false
            this.note = true
            this.paperSorce = true
            this.isTrue = false
        },
         // 根据试卷ID查询题目列表
        getTopicPage(){
            getAllTopic({id:this.$route.query.id})
           .then(res =>{
            if(res.code == 0){
              this.questions = res.data || []
               this.questions.forEach(k =>{
                if(k.type == 9){
                  k.answerList.forEach((t,index) =>{
                     let patternString = `{{${index + 1}}}`;
                     k.title = k.title.replace(patternString, '_______')
                  })
                }
                if(k.type == 7){
                  let indexedArray = k.answerList.map((item, index) => ({ item, index }));  
                   indexedArray.sort((a, b) => a.item.sort - b.item.sort);   
                    k.sortedIndexes = indexedArray.map(item => item.index); 
                }
              }) 
            }
            }) 
        },
          // 获取试卷详情
        getPaperDetail(){
            getPaper({id:this.$route.query.id},'get')
            .then(res =>{
              this.list = res.data
            })
            .catch(err =>{})
        },
    },
}
</script>
<style lang="scss" scoped>
.text-center{
    text-align: center;
}
.text-left{
    text-align: left;
}
.default-div{
    margin: 15px 0 15px 50px;
    padding: 0 0 0 90px;
}
.publicViewClass{
    height: inherit;
    overflow: hidden;
}
.app-inner{
    background: #f7f8fa !important;
    padding: 0 !important;
    height: calc(100% - 90px);
}
.height-100{
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    .left{
        .question-content{
            position: relative;
            float: unset;
            margin: 0 20px 0 0;
           width: unset;
            min-height: 100%;
            padding: 50px 190px 80px 50px;
            box-shadow: 0px 0px 10px 0px rgba(11, 34, 51, 0.05);
            border-radius: 10px;
            background-color: #fff;
            .split-line{
                position: absolute;
                width: 140px;
                height: 100%;
                border-right: 1px dashed #bbb;
                top: 0;
                left: 0;
                .edit-show{
                        position: absolute;
                        right: 50px;
                        top: 100px;
                        transform: rotateZ(-90deg);
                        transform-origin: right bottom;
                        white-space: nowrap;
                        font-size: 20px;
                        color: #000000;
                }
                .split-line-font{
                        position: absolute;
                        top: 30%;
                        right: -7px;
                        color: #bbb;
                        font-size: 14px;
                        background-color: #fff;
                }
            }
            .question-title {
                    font-size: 36px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 50px;
                    letter-spacing: 0px;
                    color: #000000;
                    margin-bottom: 15px;
            }
            .question-time{
                margin-bottom: 20px;
            font-weight: 300;
            font-size: 16px;
            }
            .question-precautions{
                font-size: 15px;
                line-height: 15px;
                margin-bottom: 70px;
            }
            .question-topic{
                    font-size: 16px;
                    line-height: 36px;
                    color: #000000;
                        .ques-title{
        font-size: 17px;
          vertical-align: middle;
          line-height: 35px;
          -webkit-margin-before: 0;
          -webkit-margin-after: 0;
          word-break: break-word;
          .ques-number {
            font-size: 17px;
            padding: 0;
            background-color: transparent;
            color: #222;
        }
        .ques-type{
          margin: 0 12px;
        }
        .ques-sorce{
          color: #aeaeae;
        }
      }
        .question-option-list{
                padding: 0 20px;
                margin-top: 30px;
                .olf{
                    flex-wrap: wrap;
                }
                li{
                    width: 25%;
                    list-style-type: upper-latin;
                    margin-bottom: 15px;
                    font-size: 17px;
                }
                // li::marker{
                //     unicode-bidi: isolate;
                // font-variant-numeric: tabular-nums;
                // text-transform: none;
                // text-indent: 0px !important;
                // text-align: start !important;
                // text-align-last: start !important; 
                // }
                .test_result{
                    margin-left: -20px;
                    .rightAnswer{
                        color: #36aafd;
                    }
                    .jx{
                        color: #999;
                        padding-top: 10px;
                    }
                }
            }
            }
        }
    }
    .g-question{
     position: sticky;
     top: 0;
     .btn-group {
        cursor: pointer;
        width: 100%;
    margin-bottom: 30px;
    position: relative;
    display: block;
    width: 100%;
    height: 60px;
    background-color: #36aafd;
    text-align: center;
    border: 1px solid #36aafd;
    -webkit-border-radius: 10px !important;
    -moz-border-radius: 10px !important;
    border-radius: 10px !important;
    overflow: hidden;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 55px;
    letter-spacing: 0px;
    color: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(54, 170, 253)
     }
     .j-paper-style{
        width: 300px;
    padding: 0!important;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(11, 34, 51, 0.05);
    border-radius: 10px;
        position: relative;
    padding: 24px;
    font-size: 16px;
    font-weight: bold;
    .content-title{
    height: 56px;
    line-height: 56px;
    background-color: #ffffff;
    border-bottom: solid 1px #e6e6e6;
    border-radius: 10px 10px 0 0;
    font-size: 20px;
    color: #333333;
    font-weight: 600;
    cursor: default;
    .left{
        flex: 1;
    }
    
    }
    .paper-label{
        margin-top: 20px;
        .isShowBtn{
            margin-bottom: 20px;
            height: 40px;
            line-height: 40px;
            background-color: #ffffff;
            border-radius: 5px !important;
            border: solid 1px #36aafd;
            color: #36aafd;
            text-align: center;
            cursor: pointer;
        }
    }
     }
    }
}
::v-deep{
      .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>